<template>
  <div class="text-xs">
    <div class="bg-[#022239]">

      <div class="flex justify-between items-center px-4 py-6">
        <img src="../../../assets/bowsys.png" class="w-32" alt="" />


        <div class="hidden lg:flex items-center gap-4 font-bold text-bgColor">

          <input type="text" class="border p-2 w-96 rounded-sm bg-gray-200 text-gray-600" placeholder="Search ..." />

          <button class="bg-[#02324B] h-10 flex items-center gap-4 px-3 rounded-sm">
            {{ formattedDate }}
            <font-awesome-icon icon="fa-calendar" class="h-3 w-3" />
          </button>

          <button class="bg-[#02324B] h-10 flex items-center gap-4 px-3 rounded-sm">
            Bowsys
            <font-awesome-icon icon="fa-chevron-down" class="h-3 w-3" />
          </button>

          <button class="flex items-center justify-center gap-2 bg-[#02324B] rounded-sm h-10 px-4">
            <font-awesome-icon icon="fa-user" class="h-3 w-3" />
            <p>{{ user.familyName }} {{ user.givenName }}</p>
          </button>

          <button @click="handleLogoutButton" class="flex items-center justify-center gap-2 bg-[#02324B] rounded-sm h-10 px-4">
            <font-awesome-icon icon="fa-logout" class="h-3 w-3" />
            <p>Logout</p>
          </button>
        </div>

        <!-- Mobile Burger Button -->
        <button class="lg:hidden text-white" @click="isMobileMenuOpen = !isMobileMenuOpen">
          <font-awesome-icon icon="fa-bars" class="text-xl" />
        </button>
      </div>


      <div
        v-if="isMobileMenuOpen"
        class="lg:hidden flex flex-col gap-3 px-4 pb-6 text-white"
      >

        <input
          type="text"
          class="border border-gray-400 p-2 w-full rounded-md bg-white text-gray-800 placeholder-gray-500"
          placeholder="Search ..."
        />


        <button class="bg-[#02324B] h-10 flex items-center justify-between px-4 rounded-md text-sm">
          <span>{{ formattedDate }}</span>
          <font-awesome-icon icon="fa-calendar" class="h-4 w-4" />
        </button>


        <div class="relative">
          <button 
            class="bg-[#02324B] h-10 flex items-center justify-between px-4 rounded-md text-sm w-full"
            @click="isBowsysDropdownOpen = !isBowsysDropdownOpen"
          >
            <span>Bowsys</span>
            <font-awesome-icon 
              :icon="isBowsysDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'" 
              class="h-4 w-4" 
            />
          </button>

          <!-- Mobile Navigation Dropdown -->
          <div 
            v-if="isBowsysDropdownOpen" 
            class="bg-[#033456] flex flex-col gap-2 mt-1 rounded-md overflow-hidden p-2"
          >
            <router-link
              v-for="r in routes"
              :key="r.name"
              :to="r.path"
              :class="[
                'flex items-center gap-2 p-3 rounded hover:bg-[#02324B]',
                isMainRoute == r.name ? 'bg-[#02324B] text-white' : 'text-gray-300'
              ]"
              @click="setSelectedRoute(r); isBowsysDropdownOpen = false; isMobileMenuOpen = false"
            >
              <font-awesome-icon :icon="r.icon" class="h-4 w-4" />
              <span>{{ r.name }}</span>
            </router-link>
          </div>
        </div>


        <button class="flex items-center gap-2 bg-[#02324B] rounded-md h-10 px-4 text-sm justify-center">
          <font-awesome-icon icon="fa-user" class="h-4 w-4" />
          <span> {{ user.familyName }} {{ user.givenName }}</span>
        </button>


        <button
          @click="handleLogoutButton"
          class="flex items-center gap-2 bg-red-600 hover:bg-red-700 rounded-md h-10 px-4 text-sm justify-center"
        >
          <font-awesome-icon icon="fa-sign-out-alt" class="h-4 w-4" />
          <span>Logout</span>
        </button>
      </div>



      <div class="hidden lg:flex items-center gap-2 text-gray-400 px-4 py-2 overflow-x-auto">
        <router-link
          v-for="r in routes"
          :key="r.name"
          :to="r.path"
          :class="isMainRoute == r.name ? 'border-b border-gray-100 text-gray-100' : ''"
          @click="setSelectedRoute(r)"
          class="flex gap-2 p-2 items-center whitespace-nowrap"
        >
          <font-awesome-icon :icon="r.icon" class="h-3 w-3" />
          {{ r.name }}
        </router-link>
      </div>
    </div>

    <!-- Subroutes -->
    <div class="bg-gray-200 flex items-center gap-6 h-10 px-4 overflow-x-auto" v-if="selectedRoute?.children">
      <router-link
        v-for="child in selectedRoute?.children"
        :key="child.name"
        :to="child.path"
        :class="isCurrentRoute(child.path)"
        class="whitespace-nowrap"
      >
        {{ child.name }}
      </router-link>
    </div>
      <slot></slot>
  
  </div>
</template>

<script>
  import { ref, computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import Cookies from 'js-cookie'

  export default {
    name: 'BowsysNavbar',
    setup() {
      const route = useRoute()
      const store = useStore()
      const organizations = ref([])
      const companyName = ref('')
      const isMobileMenuOpen = ref(false)
      const isBowsysDropdownOpen = ref(false)

      const handleLogoutButton = () => {
        Cookies.remove('bowsystoken')
        window.location.href = 'https://boyo.mn/bowsys/login'
      }

      const setSelectedRoute = async (route) => {
        await store.dispatch('bowsys/fetchRoute', route)
        isMobileMenuOpen.value = false // цэс сонгоход хаах
      }

      const routes = ref([
        {
          name: 'Данс бүртгэл',
          path: '/bowsys/accounts-list',
          icon: 'fa-pen',
        },
        {
          name: 'Цалин',
          icon: 'fa-wallet',
          path: '/bowsys/employee',
          children: [
            { name: '1. Ажилтаны мэдээлэл', path: '/bowsys/employee' },
            { name: '2. Цалин тооцоо', path: '/bowsys/salary' },
            { name: '3. Үзүүлэлт', path: '/bowsys/statistics' },
          ],
        },
        {
          name: 'Бараа материал',
          path: '/bowsys/goods',
          icon: 'fa-brands fa-product-hunt',
        },
        {
          path: '/bowsys/fixed-asstes',
          name: 'Үндсэн хөрөнгө',
          icon: 'fa-building-user',
        },
        {
          path: '/bowsys/general-journal',
          name: 'Ерөнхий журнал',
          icon: 'fa-book',
        },
        {
          path: '/bowsys/balance',
          name: 'Гүйлгээ баланс',
          icon: 'fa-scale-balanced',
        },
        {
          name: 'Тайлан',
          icon: 'fa-layer-group',
          path: '/bowsys/ct1',
          children: [
            { path: '/bowsys/ct1', name: '1. Ct_1' },
            { path: '/bowsys/ct2', name: '2. Ct_2' },
            { path: '/bowsys/ct3', name: '3. Ct_3' },
            { path: '/bowsys/ct4', name: '4. Ct_4' },
          ],
        },
      ])

      const selectedRoute = computed(() => store.getters['bowsys/getRoute'])
      const user = computed(() => store.getters['bowsys/getUser'])
      console.log("A1", store.getters['bowsys/getUser'])
      const isMainRoute = computed(() => selectedRoute.value?.name || '')

      const isCurrentRoute = (path) => {
        return {
          'font-bold text-[#022239]': route.path === path,
          'text-gray-600': route.path !== path,
        }
      }

      const formattedDate = computed(() => {
        return new Date().toLocaleDateString('en-CA')
      })

      return {
        routes,
        user,
        setSelectedRoute,
        selectedRoute,
        isCurrentRoute,
        isMainRoute,
        organizations,
        companyName,
        formattedDate,
        handleLogoutButton,
        isMobileMenuOpen,
        isBowsysDropdownOpen
      }
    },
  }
</script>